// ==============================|| OVERRIDES - FORM HELPER TEXT ||============================== //

export default function FormHelperText() {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: { marginTop: 4, marginLeft: 0, marginRight: 0, fontSize: '0.71875rem', lineHeight: 1.4 }
      }
    }
  };
}
